import Super from '../../../core/menu/item.gjs';

export default class SpdsInputSearchMenuItem extends Super {
  variantClass = 'spds-input-search-menu-item';
}
